import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

import useApi from '@/hooks/useApi';

import { getDetails } from '@/services/requests/Details';
import {
  TCard,
  TConfig,
} from '@/services/requests/Recommendation/types/template2';

import { getValue } from '@/helpers/GetValueHelper';

import { TCardDetail } from './interface';

type TUseDetailsProps = {
  cards: TCard[];
  config: TConfig;
};

export const useDetails = ({ cards, config }: TUseDetailsProps) => {
  const cardsMapped = cards.map(card => {
    if (card.details) {
      const loadingText = 'Carregando...';
      const tempText = card.text_5;
      return {
        ...card,
        text_5: loadingText,
        text_5_temp: tempText,
        loaded: false,
      };
    }

    return {
      ...card,
      loaded: true,
    };
  }) as TCardDetail[];

  const { Api } = useApi();

  const [cardsDetails, setCardsDetails] = useState(cardsMapped);

  const changeDetails = (promises: any[], startIndex = 0) => {
    const newCardsDetails = [...cardsDetails];

    promises.forEach(({ status, value }, index) => {
      const newIndex = index + startIndex;
      let newItem = {} as TCardDetail;
      if (status === 'fulfilled') {
        newItem = {
          ...newCardsDetails[newIndex],
          cta: [
            {
              channel:
                getValue(
                  value,
                  'cta.channel',
                  getValue(value, 'cta[0].channel', ''),
                ) || getValue(newCardsDetails[newIndex], 'cta[0].channel', ''),
              link:
                getValue(
                  value,
                  'cta.link',
                  getValue(value, 'cta[0].link', ''),
                ) || getValue(newCardsDetails[newIndex], 'cta[0].link', ''),
            },
          ],
          text_1: value.text_1 || newCardsDetails[newIndex].text_1,
          text_2: value.text_2 || newCardsDetails[newIndex].text_2,
          text_3: value.text_3 || newCardsDetails[newIndex].text_3,
          text_4: value.text_4 || newCardsDetails[newIndex].text_4,
          text_5: value.text_5 || newCardsDetails[newIndex].text_5_temp,
          text_6: value.text_6 || newCardsDetails[newIndex].text_6,
          loaded: true,
        };
      } else {
        newItem = {
          ...newCardsDetails[newIndex],
          text_5: getValue(newCardsDetails[newIndex], 'text_5_temp', ''),
          loaded: true,
        };
      }
      setCardsDetails(prev =>
        prev.map((obj, key) => (key === newIndex ? newItem : obj)),
      );
    });
  };

  const fetchDetails = async (start: number, end: number) => {
    const promises = [] as any[];

    cardsDetails.slice(start, end).forEach(item => {
      let promise = Promise.resolve({ ...item });
      if (item.details && !item.loaded) {
        promise = getDetails(Api, item.details) as any;
      }
      promises.push(promise);
    });

    changeDetails(await Promise.allSettled(promises), start);
  };

  useEffect(() => {
    fetchDetails(0, 4);

    if (isMobile) {
      if (cardsDetails.length > 4) {
        fetchDetails(4, cardsDetails.length);
      }
    }
  }, []);

  return { cardsDetails, fetchDetails };
};
